<div class="header-bar">
  <div class="image-container">
    <img src="./assets/img/logo-schenck-one-weiss.png" alt="Schenck ONE Logo" />
  </div>
  <div class="app-name">Account Manager</div>
  @if (loginDisplay) {
    <div class="user-info">
      <rotec-icon-v2
        class="language-icon"
        svgIcon="language"
        (click)="openLanguageModal()"
      ></rotec-icon-v2>
      <span class="user-name" (click)="toggleUserMenu()" #username>{{ user }}</span>
      <div class="logout" [class.hidden]="hideUserMenu" (click)="logout()">
        <rotec-icon-v2 svgIcon="on-off" color="gray" class="logout-icon"></rotec-icon-v2>
        <span>Logout</span>
      </div>
    </div>
  }
</div>
